'use client';

/**
 * CenterPin — pin CỐ ĐỊNH ở tâm màn hình (không phải maplibre Marker). Đặt
 * tuyệt đối giữa map container; mũi pin trỏ đúng tâm map. Khi `isMoving` (đang
 * pan) pin nhấc lên + phóng nhẹ, bóng dưới đất co lại — tạo cảm giác nhấc lên.
 * Micro-interaction bằng framer-motion (đã có trong app).
 */
import { cn } from '@ahm/common-helpers';
import { motion } from 'framer-motion';

export type CenterPinProps = {
  /** Đang pan map (chưa idle) → nhấc pin + co bóng. */
  isMoving?: boolean;
  /** Class màu thân pin (dùng token). Mặc định `text-primary` (cam AhaFood). */
  className?: string;
};

const SPRING = { type: 'spring', stiffness: 500, damping: 30 } as const;

export default function CenterPin({
  isMoving = false,
  className = 'text-primary',
}: CenterPinProps) {
  return (
    <div
      className={cn(
        'pointer-events-none absolute left-1/2 top-1/2 z-10 h-0 w-0',
        className
      )}
    >
      {/* Bóng đổ trên mặt đất — neo tại đúng tâm */}
      <div className="absolute left-0 top-0 -translate-x-1/2 -translate-y-1/2">
        <motion.span
          className="block h-[6px] w-[18px] rounded-[100%] bg-black/40 blur-[2px]"
          animate={{
            scaleX: isMoving ? 0.55 : 1,
            opacity: isMoving ? 0.25 : 0.4,
          }}
          transition={SPRING}
        />
      </div>

      {/* Thân pin — mũi nhọn đặt đúng tâm (bottom = điểm neo) */}
      <div className="absolute left-0 top-0 -translate-x-1/2 -translate-y-full">
        <motion.div
          style={{ transformOrigin: 'bottom center' }}
          animate={{ y: isMoving ? -10 : 0, scale: isMoving ? 1.08 : 1 }}
          transition={SPRING}
        >
          <svg
            width="34"
            height="46"
            viewBox="0 0 34 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
          >
            <path
              d="M17 0C7.611 0 0 7.611 0 17c0 12.02 14.87 27.29 15.503 27.93a2.1 2.1 0 0 0 2.994 0C19.13 44.29 34 29.02 34 17 34 7.611 26.389 0 17 0Z"
              fill="currentColor"
            />
            <circle cx="17" cy="16.5" r="6" fill="#fff" />
          </svg>
        </motion.div>
      </div>
    </div>
  );
}
